import Vue from "vue";
import { PersonnelService, } from "../../common/api.service";
import { SET_TOASTER_MESSAGE } from "../this_app/mutations";
import {
    CANCEL_PERSON_AVAILABILITY_EDIT_STATE,
    DELETE_PERSON_AVAILABILITY,
    FETCH_PERSON_AVAILABILITY_LIST,
    SAVE_EDITED_PERSON_AVAILABILITY,
    SAVE_NEW_PERSON_AVAILABILITY,
    UPDATE_AVAILABILITY,
} from "./actions.js";
import {
    FETCH_PERSON_AVAILABILITYS_END,
    LOAD_PERSON_AVAILABILITY_TO_EDIT,
    RESET_DEFAULT_NEW_PERSON_AVAILABILITY,
    RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT,
    TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG,
    TOGGLE_NEW_PERSON_AVAILABILITY_DIALOG,
    TOGGLE_PERSON_AVAILABILITY_EDIT_STATE,
    UPDATE_ADD_PERSON_AVAILABILITY_FIELD,
    UPDATE_EDIT_PERSON_AVAILABILITY_FIELD,
} from "./mutations.js";

const state = {
    editPersonAvailabilityInitialLoadYear: undefined,
    personAvailabilityList: [],
    editStateAvailability: {
        employmentType: false,
        weeklyHours: false,
        startDate: false,
        endDate: false,
        comments: false,
    },
    editPersonAvailability: {},
    defaultPersonAvailability: {
        year: undefined,
        workingDays: 0,
        carriedOver: 0,
        holidayEntitlement: 0,
        specialAllowance: 0,
        bankHolidayDays: 0,
        comments: null,
    },
    addPersonAvailability: {},
    addPersonAvailabilityDialog: false,
    editPersonAvailabilityDialog: false,
    yearList: [],
};

const getDefaultState = () => {
    return {
        defaultPersonAvailability: {
            personId: undefined,
            year: undefined,
            workingDays: 0,
            carriedOver: 0,
            holidayEntitlement: 0,
            specialAllowance: 0,
            bankHolidayDays: 0,
            comments: undefined,
        },
    }
};

const years = function () {
    const currentYear = new Date().getFullYear();
    const tenYearsTime = currentYear + 10;
    let years = [];
    for (let i = 2015; i <= tenYearsTime; i++) {
        years.push(i);        
    }
    return years;
};


const getters = {
    currentYear() {
        let year = 0;
        const today = new Date();
        if ((today.getMonth() + 1) <= 3) {
            year = (today.getFullYear() - 1)
        } else {
            year = today.getFullYear()
        }
        return year
    },
    editPersonAvailabilityInitialLoadYear(state) {
        return state.editPersonAvailabilityInitialLoadYear;
    },
    yearList() {
        return years();
    },
    yearsRemainingForPersonExceptEditYearList(state, getters) {
        let exceptYear = false;
        if (getters.editPersonAvailabilityInitialLoadYear) {
            exceptYear = getters.editPersonAvailabilityInitialLoadYear;
        }

        const interimArray = Object.freeze(getters.yearList);
        let yearsRemainingForPersonList = JSON.parse(JSON.stringify(interimArray));
        const yearListToIterate = interimArray;
        let yearFoundInExistingHoliday = false;

        // Loop through years
        for (let i = 0; i <= yearListToIterate.length; i++) {
            const element = yearListToIterate[i];
            yearFoundInExistingHoliday = false;
            // Loop through persons holiday years
            for (let item of getters.personAvailabilityList) {
                // If current fiscal year is in the person year list
                if (item.year == element) {
                    yearFoundInExistingHoliday = true;
                    // If this year is not the except year then its in the list
                    if (item.year == exceptYear) {
                        yearFoundInExistingHoliday = false;
                    }
                }
            }

            if (yearFoundInExistingHoliday) {
                const index = yearsRemainingForPersonList.indexOf(element);
                if (index !== -1) yearsRemainingForPersonList.splice(index, 1);
            }
        }
        return yearsRemainingForPersonList;
    },
    addPersonAvailabilityDialog(state) {
        return state.addPersonAvailabilityDialog;
    },
    editPersonAvailabilityDialog(state) {
        return state.editPersonAvailabilityDialog;
    },
    personAvailabilityList(state) {
        return state.personAvailabilityList;
    },
    editedAvailabilityItem(state) {
        return state.editedAvailabilityItem;
    },
};

const actions = {
    [FETCH_PERSON_AVAILABILITY_LIST]({commit}, personId) {
        if (personId == undefined) {
            return false;
        }
        return PersonnelService.getPersonAvailabilitys(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_AVAILABILITYS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch availability'});
            });
    },
    [CANCEL_PERSON_AVAILABILITY_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_AVAILABILITY_LIST, params.personId);
        commit(TOGGLE_PERSON_AVAILABILITY_EDIT_STATE, params.field);
    },
    [UPDATE_AVAILABILITY]({commit, dispatch}, params) {
        return PersonnelService.updatePersonAvailability(state.editPersonAvailability)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT);
                dispatch(FETCH_PERSON_AVAILABILITY_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update availability'});
            });
    },
    [DELETE_PERSON_AVAILABILITY]({dispatch, commit}, params) {
        return PersonnelService.deletePersonAvailability(params.personAvailabilityId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_AVAILABILITY_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete availability'});
            });
    },
    [SAVE_NEW_PERSON_AVAILABILITY]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonAvailability = state.addPersonAvailability;
        return PersonnelService.savePersonAvailability(newPersonAvailability)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_AVAILABILITY_LIST, newPersonAvailability.personId);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save availability'});
            });
    },

    [SAVE_EDITED_PERSON_AVAILABILITY]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonAvailability = state.editPersonAvailability;
        return PersonnelService.updatePersonAvailability(editedPersonAvailability)
            .then(({data}) => {
                commit(RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT);
                dispatch(FETCH_PERSON_AVAILABILITY_LIST, editedPersonAvailability.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update availability'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_NEW_PERSON_AVAILABILITY_DIALOG](state) {
        state.addPersonAvailabilityDialog = !state.addPersonAvailabilityDialog;
    },
    [TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG](state) {
        state.editPersonAvailabilityDialog = !state.editPersonAvailabilityDialog;
    },
    [RESET_DEFAULT_NEW_PERSON_AVAILABILITY](state, personId) {
        state.addPersonAvailability = getDefaultState().defaultPersonAvailability;
        state.addPersonAvailability.year = undefined;
        state.addPersonAvailability.personId = personId;
    },
    [RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT](state) {
        state.editPersonAvailability = getDefaultState().defaultPersonAvailability;
        state.editPersonAvailabilityInitialLoadYear = false;
    },
    [LOAD_PERSON_AVAILABILITY_TO_EDIT](state, AvailabilityId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personAvailabilityList.find((list) =>
            list.personAvailabilityId == AvailabilityId);
        let frozenEditItem = Object.freeze(itemToEdit);
        let jsonedEditITem = JSON.parse(JSON.stringify(frozenEditItem));
        state.editPersonAvailability = jsonedEditITem;
        const existingYear = jsonedEditITem.year;
        state.editPersonAvailabilityInitialLoadYear = existingYear;
    },
    [TOGGLE_PERSON_AVAILABILITY_EDIT_STATE](state, field) {
        state.editStateAvailability[field] = !state.editStateAvailability[field];
    },
    [UPDATE_EDIT_PERSON_AVAILABILITY_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonAvailability[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonAvailability[data.key] = data.value;
        }
    },
    [UPDATE_ADD_PERSON_AVAILABILITY_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonAvailability[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonAvailability[data.key] = data.value;
        }
    },
    [FETCH_PERSON_AVAILABILITYS_END](state, data) {
        state.personAvailabilityList = data;
        state.isLoading = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
